import angular from 'angular';
import component from './employeeCarousel.component';
import listingService from '../listing/index';
import CarsNgEmployees from 'cars-ng-employees';
import Overlays from 'cars-ng-overlays';
import NgCookies from 'angular-cookies';

export default angular.module('app.shared.employeeCarousel', [
    listingService,
    CarsNgEmployees,
    Overlays,
    NgCookies
])

.component('employeeCarousel', component)

.name;
